/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormControl, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Controller } from 'react-hook-form';

const CustomSelectAutocomplete = (props) => {
  const {
    label, name, className, classes, control,
    rule, options, error, disabled, required,
    styleFromHelperText, defaultValue,
    style, noWrap = false,
  } = props;

  return (
    <FormControl className={className} style={style} fullWidth variant="outlined">
      <Controller
        name={name}
        control={control}
        rules={rule}
        defaultValue={defaultValue !== undefined ? defaultValue : ''}
        render={({ onChange, value }) => (
          <Autocomplete
            options={options || []}
            disabled={disabled}
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, val) => {
              if (!val) return false;
              const valueToCompare = typeof val === 'object' ? val.value : val;
              return option.value === valueToCompare;
            }}
            value={
              value !== '' && value !== undefined
                ? (options.find((opt) => opt.value === (value?.value || value)) || null)
                : null
            }
            onChange={(_, data) => {
              onChange(data ? data.value : '');
            }}
            autoSelect={false}
            autoHighlight={false}
            renderOption={(option) => (
              noWrap ? (
                <Typography noWrap variant="body1" style={{ fontFamily: "'Raleway'" }}>
                  {option.label}
                </Typography>
              ) : (
                option.label
              )
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                size="small"
                variant="outlined"
                required={required}
                className={classes}
                error={Boolean(error[name])}
                helperText={error[name] ? error[name].message : null}
                FormHelperTextProps={styleFromHelperText || { style: { margin: '0 0 0 5px', color: '#d61103' } }}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password',
                }}
              />
            )}
          />
        )}
      />
    </FormControl>
  );
};

export default CustomSelectAutocomplete;
